import { render, staticRenderFns } from "./TondoInfoTabs.vue?vue&type=template&id=a86c9a6e"
import script from "./TondoInfoTabs.vue?vue&type=script&lang=ts"
export * from "./TondoInfoTabs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports